export function initPackageDetails() {
  const toggles = document.querySelectorAll('.package-details-toggle');
  if (!toggles.length) return;

  toggles.forEach((btn) => {
    const details = btn.nextElementSibling; // .package-details
    if (!details) return;

    btn.addEventListener('click', () => {
      const open = details.classList.toggle('is-open');
      btn.classList.toggle('is-open', open);
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });
}
